import { HStack, VStack } from 'native-base';
import { lazy, Suspense, useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import Loading from 'ui/components/v2/Loading';
import { Tab } from 'ui/components/v2/Tab';

const ConnectionsTab = lazy(() =>
  import('./ConnectionsTab').then((m) => ({ default: m.ConnectionsTab })),
);

const MyConnectionsTab = lazy(() =>
  import('./MyConnectionsTab').then((m) => ({ default: m.MyConnectionsTab })),
);

enum Tabs {
  FindConnections = 0,
  MyConnections = 1,
}

export const Network = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const currentTab = useMemo(() => {
    const tab = Number(searchParams.get('networkTabs') || Tabs.FindConnections);
    return tab as Tabs;
  }, [searchParams]);

  const [tabIndex, setTabIndex] = useState<Tabs>(currentTab);

  const handleChangeTab = (tab: Tabs) => {
    setTabIndex(tab);
    // Criando um novo objeto URLSearchParams para evitar mutação
    const newParams = new URLSearchParams(searchParams);
    newParams.set('networkTabs', String(tab));
    // Atualizando URL de forma assíncrona usando queueMicrotask
    queueMicrotask(() => setSearchParams(newParams));
  };

  const tabObject: Record<Tabs, JSX.Element> = useMemo(
    () => ({
      [Tabs.FindConnections]: <ConnectionsTab />,
      [Tabs.MyConnections]: <MyConnectionsTab />,
    }),
    [],
  );

  return (
    <VStack
      w={'full'}
      minH={'full'}
      alignItems={'center'}
      pt={8}
      px={{ base: 4, md: 6, xl: 12 }}
    >
      {/* Chosen tabs */}
      <HStack width="full">
        <Tab
          key="find-connections"
          label="Find connections"
          description="Discover candidates for your opportunities"
          icon="search"
          isActive={tabIndex === Tabs.FindConnections}
          onPress={() => handleChangeTab(Tabs.FindConnections)}
        />
        <Tab
          key="my-connections"
          label="My connections"
          description="Manage your audiences"
          icon="users"
          isActive={tabIndex === Tabs.MyConnections}
          onPress={() => handleChangeTab(Tabs.MyConnections)}
        />
      </HStack>

      <VStack width="full">
        <Suspense fallback={<Loading backgroundColor="white" height="80vh" />}>
          {tabObject[tabIndex]}
        </Suspense>
      </VStack>
    </VStack>
  );
};
